(function () {
  if (customElements.get('divano-recently-viewed')) return;

  const STORAGE_KEY = 'viewedProducts';

  function readIds() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const ids = JSON.parse(raw || '[]');
      return Array.isArray(ids) ? ids.filter((id) => typeof id === 'string' && id.length > 0) : [];
    } catch (err) {
      return [];
    }
  }

  class DivanoRecentlyViewed extends HTMLElement {
    connectedCallback() {
      this._hydrating = false;
      const pending = this.querySelector('[data-pending]');
      if (pending) {
        this._hydrate();
      }
    }

    async _hydrate() {
      if (this._hydrating) return;
      this._hydrating = true;

      try {
        const currentId = this.dataset.currentProductId || '';
        const limit = parseInt(this.dataset.limit || '4', 10);
        let ids = readIds();
        if (currentId) ids = ids.filter((id) => id !== currentId);
        if (ids.length === 0) {
          this.style.display = 'none';
          return;
        }

        const route = this.dataset.route || '/search';
        const sectionId = this.dataset.sectionId || 'divano-recently-viewed';
        const query = ids.map((id) => `id:${id}`).join(' OR ');
        const url = `${route}?q=${encodeURIComponent(query)}&resources[type]=product&section_id=${encodeURIComponent(sectionId)}`;

        const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('divano-recently-viewed');
        if (!fresh) return;

        const items = fresh.querySelectorAll('.divano-recently-viewed__item:not(.divano-recently-viewed__item--skeleton)');
        if (items.length === 0) {
          this.style.display = 'none';
          return;
        }

        let dropped = 0;
        if (currentId) {
          fresh.querySelectorAll('.divano-recently-viewed__item').forEach((li) => {
            const href = li.querySelector('a')?.getAttribute('href') || '';
            if (href.includes('/products/') && href.match(/-${currentId}$/)) {
              li.remove();
              dropped++;
            }
          });
        }
        const remaining = fresh.querySelectorAll('.divano-recently-viewed__item:not(.divano-recently-viewed__item--skeleton)');
        Array.from(remaining).slice(limit).forEach((el) => el.remove());

        if (remaining.length - dropped <= 0) {
          this.style.display = 'none';
          return;
        }

        this.innerHTML = fresh.innerHTML;
        this.style.display = '';
      } catch (err) {
      } finally {
        this._hydrating = false;
      }
    }
  }

  customElements.define('divano-recently-viewed', DivanoRecentlyViewed);
})();
